import {
  POLLING_START,
  POLLING_STOP,
  POLLING_SET_TIMEOUT,
} from '../reducers/polling';

export const startPollingFor = obj => ({
  type: POLLING_START,
  payload: {
    object: obj,
  },
});

export const setPollingTimeoutFor = (obj, timeoutId) => ({
  type: POLLING_SET_TIMEOUT,
  payload: {
    object: obj,
    timeoutId,
  },
});

export const stopPollingFor = obj => ({
  type: POLLING_STOP,
  payload: {
    object: obj,
  },
});

export const resetPollingFor = obj => (dispatch, getState) => {
  clearTimeout(getState().polling[obj].timeoutId);
  return dispatch(stopPollingFor(obj));
};

export const resetPolling = () => (dispatch, getState) => {
  const { polling } = getState();

  const keys = Object.keys(polling);
  for (let i = keys.length - 1; i >= 0; i -= 1) {
    dispatch(resetPollingFor(keys[i]));
  }
};



// WEBPACK FOOTER //
// ./src/actions/polling.js